<template>
        <div>
            <ul class="transport-box">
                <li style="float: right">
                    <button class="icon-btn" @click="clickEdit"><font-awesome-icon icon="fa-regular fa-pen-to-square" /></button>
                    <button class="icon-btn close-btn" @click="clickDelete"><font-awesome-icon icon="fa-solid fa-xmark" /></button>
                </li>

                <li class="transport-content">
                    <span tkey="中文名稱">{{i18n.tkey("lang_cn_name")}}</span>：{{obj.ProductName}}
                </li>

                <li class="transport-content">
                    <span tkey="英文名稱">{{i18n.tkey("lang_en_name")}}</span>：{{obj.ProductNameCN}}
                </li>

                <li class="transport-content">
                    <span tkey="運費">{{i18n.tkey("lang_d_cost")}}</span>：{{obj.Cost}}
                </li>
            </ul>
        </div>
</template>

<script setup>
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faPenToSquare } from '@fortawesome/free-regular-svg-icons'
    import { faXmark } from '@fortawesome/free-solid-svg-icons'
    import myUtil from "@/util/util";
    import {inject} from "vue";

    library.add(faPenToSquare, faXmark)

    const props = defineProps(['obj'])
    const emits = defineEmits(['clickEdit', 'clickDelete'])

    const i18n = inject("i18n")

    function clickEdit() {
        emits("clickEdit", props.obj)
    }

    function clickDelete() {
        myUtil.confirmWarning(i18n.tkey("lang_delete_confirm"), () => {
            emits("clickDelete", props.obj)
        })
    }
</script>

<style scoped>
    .transport-box {
        padding: 0;
        list-style: none;
        font-size: 14px;
        border: 1px #ddd solid;
        border-radius: 10px;
        padding-bottom: 10px;
        margin-bottom: 10px;
        text-align: left;
        padding-top: 10px;
    }

    .transport-box .transport-operatin {
        /*text-align: right;*/
        line-height: 2.5;
        display: flex;
        background: #fff4f4;
        align-items: center;
        justify-content: space-between;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .transport-box .transport-operatin .transport-title {
        font-weight: 600;
    }

    .transport-box .transport-content {
        line-height: 2;
        padding-right: 15px;
        padding-left: 15px;
        color: #303133;
    }

    .icon-btn {
        font-size: 22px;
        margin-right: 10px;
        background-color: #FFF0;
        border: 0;
        cursor: pointer;
    }

    .close-btn {
        color: #e83f33;
    }
</style>